import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import styles from "./AddBattery.module.scss";
import { getRequest, postRequest, putRequest } from "services/axiosBaseClient";
import Master from "../Master";
import { useHistory, Link } from "react-router-dom";
import TableAndSearch from "components/common/TableAndSearch";
import notificationService from "services/notification.service";
import { NotificationManager } from "react-notifications";
import LocalStorageService from "services/tokenlocalstorage.service";
import { getRequestInFileDownload } from "services/axiosFileDownloadService";
import jwt_decode from "jwt-decode";

var test;
var id = undefined;
var userEnterprise = "";
var enterpriseName = "";
var action = "Submit";
var title = "Add Model";
var view = undefined;
var onlyView = false;
var readOnlyField = false;
var headerFilterParms;
var headerFilter = false;
var tempSearch;
var tableSearchKey;
var fileName = "";
var tempExt = "";
var trimeFileName = "";
var fileIndexValue = "";
const currentYear = new Date().getFullYear();
const range = (start, stop, step) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
const unique = range(currentYear, currentYear - 20, -1);
const typeList = ["BATTERY", "SWAPSTATION", "VEHICLE"];
function AddModelForm(props) {
  const initialFormValues = {
    name: "",
    type: "",
    description: "",
    enterprise: "",
    totalBatteries: "1",
    chargeCapacity: "",
    makeId: "-1",
    year: "",
  };

  const [choosenFileName, setChoosenFileName] = useState("No file Choosen");
  const [file, setFile] = useState(null);
  const [specFileTrigger, setSpecFileTrigger] = useState(false);
  const [tempChoosenFileName, setTempChoosenFileName] =
    useState("No file Choosen");
  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState("");
  const [recordUpdate, setRecordUpdate] = useState(false);
  const [toggleRemoveBtn, setToggleRemoveBtn] = useState(true);
  const [manufacturerList, setManufacturerList] = useState([]);
  // activepageCount setActivePageCount
  const history = useHistory();

  const getModelDataByID = async (id, enterpriseName) => {
    await getRequest(`model/get?enterprise=${"enterprise2"}&id=${id}`)
      .then((res) => {
        if (res.data != null) {
          patchForm(res.data[0]);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  };

  const patchForm = (data) => {
    setFormErrors("");
    getMakeList(data?.type ? data?.type : "");
    setFormValues({
      makeId: data?.makeId ? data?.makeId : "",
      name: data?.name ? data?.name : "",
      description: data?.description ? data?.description : "",
      type: data?.type ? data?.type : "",
      id: data?.id ? data?.id : data.id,
      enterprise: data?.enterprise,
      totalBatteries: data?.totalBatteries,
      chargeCapacity: data?.chargeCapacity,
      year: data?.year,
    });
    window.scrollTo({ top: 0 });
  };

  id = props.match.params.id;
  view = props.match.params.view;

  const routeChange = () => {
    history.push({
      pathname: "/Assets",
      state: { table: 5, compomentRenderType: "view" },
    });
  };

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("token"));
    const { accessToken } = token;
    const decodedToken = jwt_decode(accessToken);
    userEnterprise = decodedToken.group[0];
    formValues.enterprise = userEnterprise;
  }, []);

  const getMakeList = useCallback(async (type) => {
    await getRequest("make/get?type=" + type + "&enterprise" + userEnterprise)
      .then((res) => {
        if (res?.data?.length > 0) {
          setManufacturerList(res.data);
          //props.assetCount(()=>res.data.count);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "chargeCapacity") {
      const regex = /^\d{0,3}(\.\d{0,2})?$/;
      if (!regex.test(value)) {
          return;
      }
  }

    setFormValues({ ...formValues, [name]: value });
    if (name === "type") {
      getMakeList(value);
    }
    if (name === "type" && formErrors?.type) formErrors.type = "";
    if (name === "makeId" && formErrors?.makeId) formErrors.makeId = "";
    if (name === "name" && formErrors?.name) formErrors.name = "";
    if (name === "description")
      setFormValues({
        ...formValues,
        ["description"]: value.replace(/[^a-zA-Z0-9-_,@# .]+/g, ""),
      });
    // if (name === "chargeCapacity")
    //   setFormValues({
    //     ...formValues,
    //     ["chargeCapacity"]: value
    //       .replace(/[^\d.]/g, "")
    //       .replace(/^(\d*\.\d{0,2})\d*/, "$1"),
    //   });
    if (name === "type" && (value === "VEHICLE" || value === "SWAPSTATION")) {
      setFormValues({ ...formValues, [name]: value, chargeCapacity: null });
  } else {
      setFormValues({ ...formValues, [name]: value });
  }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let result = validate(formValues);

    if (Object.values(result).every((x) => x === "")) {
      var addFormData;

      if (specFileTrigger) {
        addFormData = new FormData();
        addFormData.append(
          "data",
          new Blob([JSON.stringify(formValues)], { type: "application/json" })
        );
        addFormData.append("file", file);
      } else {
        addFormData = new FormData();
        // addFormData.append("file", "");
        // addFormData.append("data", JSON.stringify(formValues));
        addFormData.append(
          "data",
          new Blob([JSON.stringify(formValues)], { type: "application/json" })
        );
      }

      if (action === "Update") {
        try {
          putRequest(
            `model/updateModel?enterprise=${formValues.enterprise}`,
            addFormData
          )
            .then((res) => {
              if (res && res?.data) {
                history.push({
                  pathname: "/Assets",
                  state: { table: 5, compomentRenderType: "view" },
                });
                notificationService.showNonBlacklisted(
                  res?.config?.url,
                  res?.data?.message
                );
              }
            })
            .catch((err) => {
              NotificationManager.error(err?.response?.data?.message);
            });
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          postRequest("model/add", addFormData)
            .then((res) => {
              if (res && res?.data) {
                history.push({
                  pathname: "/Assets",
                  state: { table: 5, compomentRenderType: "view" },
                });
                notificationService.showNonBlacklisted(
                  res?.config?.url,
                  res?.message
                );
              }
            })
            .catch((error) => {
              notificationService.showNonBlacklistedError(
                error?.config?.url,
                error?.response?.data?.message
              );
              return error;
            });
        } catch (error) {
          reset();
          console.log(error);
        }
      }
    }
  };

  const validate = (formValues) => {
    const errors = {};
    if (!formValues.name) {
      errors.name = "Model name is required!";
    } else if (!/^[ A-Za-z0-9 _.&]*$/i.test(formValues.name)) {
      errors.name = "_&. are the only allowed special characters";
    } else {
      errors.name = "";
    }

    if (!formValues.enterprise) {
      errors.enterprise = "Enterprise name is required!";
    } else {
      errors.enterprise = "";
    }

    if (
      formValues.makeId == "-1" ||
      !formValues.makeId ||
      formValues.makeId === null
    ) {
      errors.makeId = "manufacturer name is required!";
    } else {
      errors.makeId = "";
    }

    if (
      formValues.type == "-1" ||
      !formValues.type ||
      formValues.type === null
    ) {
      errors.type = "Type is required!";
    } else {
      errors.type = "";
    }

    if (
      formValues.type === "BATTERY" &&
      (!formValues.year || formValues.year == "" || formValues.year === null)
    ) {
      errors.year = "Year is required!";
    } else {
      errors.year = "";
    }

    if (
      formValues.type === "BATTERY" &&
      (!formValues.chargeCapacity ||
        formValues.chargeCapacity == "" ||
        formValues.chargeCapacity === null)
    ) {
      errors.chargeCapacity = "Charge Capacity is required!";
    } else if (
      formValues.type === "BATTERY" &&
      Number(formValues.chargeCapacity) < 1
    ) {
      errors.chargeCapacity = "Charge Capacity minimum 1 kWh!";
    } else if (
      formValues.type === "BATTERY" &&
      Number(formValues.chargeCapacity) > 100
    ) {
      errors.chargeCapacity = "Charge Capacity maximum 100 kWh !";
    } else {
      errors.chargeCapacity = "";
    }

    if (
      formValues.type === "VEHICLE" &&
      (!formValues.totalBatteries ||
        formValues.totalBatteries == "" ||
        formValues.totalBatteries === null)
    ) {
      errors.totalBatteries = "Total Batteries is required!";
    } else if (
      formValues.type === "VEHICLE" &&
      Number(formValues.totalBatteries) < 1
    ) {
      errors.totalBatteries = "Total Batteries minimum 1 !";
    } else if (
      formValues.type === "VEHICLE" &&
      Number(formValues.totalBatteries) > 10
    ) {
      errors.totalBatteries = "Total Batteries maximum 10 !";
    } else {
      errors.totalBatteries = "";
    }

    setFormErrors(errors);
    return errors;
  };

  const reset = () => {
    setFormValues(initialFormValues);
  };

  useEffect(() => {
    if (recordUpdate) {
      window.scrollTo({ top: 0 });
      setRecordUpdate(false);
    }
    enterpriseName = props.match.params.enterprise;
    if (id !== undefined && view == undefined) {
      action = "Update";
      title = "Update Model";
      readOnlyField = false;
      onlyView = false;

      getModelDataByID(id, enterpriseName);
    } else if (id !== undefined && view !== undefined) {
      action = "view";
      title = "View Model";
      readOnlyField = false;
      onlyView = true;

      getModelDataByID(id, enterpriseName);
    } else {
      title = "Add Model";
      onlyView = false;
      readOnlyField = false;
      action = "Submit";
    }
  }, [recordUpdate]);

  const removeUploadFile = (e) => {
    e.stopPropagation();
    fileName = "";
    setTempChoosenFileName(() => "No files Choosen");
    trimeFileName = "";
    setFormValues({
      ...formValues,
      ["specFilePath"]: "",
      ["fileExt"]: "",
    });
  };

  const onImageChange = (event) => {
    setSpecFileTrigger(true);
    if (event.target.files && event.target.files[0]) {
      var size = parseFloat(event.target.files[0].size / (1024 * 1024)).toFixed(
        2
      );
      if (size > 3) {
        notificationService.showNonBlacklistedError(
          "",
          "Please select image size less than 3 MB."
        );
        return false;
      }
      let img = event.target.files[0];
      const fileExtension = img.name.split(".").at(-1);
      const allowedFileTypes = ["jpg", "png", "pdf", "PDF", "JPG", "PNG"];
      setTempChoosenFileName(img.name);
      setChoosenFileName(img.name);
      setFile(img);
      test = new FormData();
      test.append("file", img);
      if (!allowedFileTypes.includes(fileExtension)) {
        setFormValues({ ...formValues, specFileActive: false });
      } else {
        setFormValues({ ...formValues, specFileActive: true });
      }
    }
  };

  const downloadFile = useCallback(async (enterprise, filePath) => {
    if (!onlyView) {
      return;
    }
    await getRequestInFileDownload(
      `downloadFile/${formValues.enterprise}?fileName=${encodeURIComponent(
        formValues.specFilePath
      )}` //${imgPath}  ${enterprise}
      //`downloadFile/enterprise1?fileName=JPEG_example_JPG_RIP_001.jpg` //${imgPath}  ${enterprise}
    ).then((res) => {
      if (res) {
        downloadPDF(res);
      }
    });
  });

  function downloadPDF(pdf) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = formValues.batterySerialNumber + "." + formValues?.fileExt;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  return (
    <>
      <div id="AddModel_block" className={cn(styles.flex_item1)}>
        <div id="AddModel_block" className={cn(styles.flex1)}>
          <h2
            id="AddModel_Heading"
            className={cn(styles.medium_title, styles.medium_title_layout)}
          >
            {"Model Detail"}
          </h2>

          <div
            id="AddModel_Form_layout"
            className={cn(styles.group, styles.group_layout)}
          >
            <form id="AddModel_Form">
              <div
                id="AddModel_Form_layout1"
                className={cn(styles.flex3, styles.flex3_layout)}
              >
                <h3
                  id="AddModel_Form_title"
                  className={cn(styles.subtitle, styles.subtitle_layout)}
                >
                  {title}
                </h3>
                <hr className={cn(styles.line, styles.line_layout)} />
                <div
                  id="AddModel_Form_row1"
                  className={cn(styles.flex2, styles.flex2_layout)}
                >
                  <div
                    id="AddModel_Name_block"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="AddModel_Name"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="AddModel_Name_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Name*"}
                      </div>
                      <input
                        id="AddModel_Name_input"
                        name="name"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues.name}
                        onChange={handleChange}
                        disabled={onlyView || readOnlyField}
                        maxLength={40}
                      />
                    </div>
                    <p>{formErrors.name}</p>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div
                    id="AddModel_EnterpriseName_block"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="AddModel_EnterpriseName"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="AddModel_EnterpriseName_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Enterprise Name*"}
                      </div>
                      <input
                        id="AddModel_EnterpriseName_input"
                        name="enterprise"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues.enterprise}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                    <p>{formErrors.enterprise}</p>
                  </div>
                </div>

                <div
                  id="AddModel_Form_row2"
                  className={cn(styles.flex2, styles.flex2_layout)}
                >
                  <div
                    id="AddModel_Type_block"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="AddModel_Type"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="AddModel_Type_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Type*"}
                      </div>

                      <select
                        id="AddModel_Type_select"
                        name="type"
                        className={cn(
                          styles.line1,
                          styles.line1_layout,
                          styles.style_select
                        )}
                        value={formValues.type}
                        onChange={handleChange}
                        disabled={onlyView || id}
                      >
                        <option value={-1}>Select Type</option>
                        {typeList.map((val) => {
                          return <option value={val}>{val}</option>;
                        })}
                      </select>
                    </div>
                    <p>{formErrors.type}</p>
                  </div>
                  <div className={cn(styles.flex2_spacer)} />
                  <div
                    id="AddModel_Manufacturer_block"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="AddModel_Manufacturer"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="AddModel_Manufacturer_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Manufacturer*"}
                      </div>

                      <select
                        id="AddModel_Manufacturer_select"
                        name="makeId"
                        className={cn(
                          styles.line1,
                          styles.line1_layout,
                          styles.style_select
                        )}
                        value={formValues.makeId}
                        onChange={handleChange}
                        disabled={onlyView}
                      >
                        <option value="-1">Select Manufacturer</option>
                        {manufacturerList.map((obj) => {
                          return <option value={obj.id}>{obj.name}</option>;
                        })}
                      </select>
                    </div>
                    <p>{formErrors.makeId}</p>
                  </div>
                </div>

                <div
                  id="AddModel_Form_row3"
                  className={cn(styles.flex2, styles.flex2_layout)}
                >
                  <div
                    id="AddModel_Description_block"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="AddModel_Description"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="AddModel_Description_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Description"}
                      </div>
                      <input
                        id="AddModel_Description_input"
                        name="description"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues.description}
                        onChange={handleChange}
                        disabled={onlyView || readOnlyField}
                        maxLength={40}
                      />
                    </div>
                    <p>{formErrors.description}</p>
                  </div>
                  <div className={cn(styles.flex2_spacer)} />
                  <div
                    id="AddModel_uploadDownload_block"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="AddModel_uploadDownload_file"
                      style={{ display: "none" }}
                      className={cn(
                        styles.block3,
                        styles.block3_layout,
                        styles.displayBlock,
                        styles.newBlock,
                        styles.upload_Fild
                      )}
                      onClick={downloadFile}
                    >
                      <input
                        type="file"
                        name="fileLocation"
                        accept="image/jpg, image/jpeg, image/png, application/pdf"
                        id="img"
                        onChange={onImageChange}
                        style={{ display: "none", width: "40%" }}
                        disabled={true}
                        onClick={(event) => {
                          const { target = {} } = event || {};
                          target.value = "";
                        }}
                      />

                      <div
                        data-for="main"
                        data-tip={tempChoosenFileName}
                        style={
                          choosenFileName == "No file Choosen" && onlyView
                            ? {
                                height: "30px",
                                width: "50%",
                                float: "left",
                                display: "flex",
                                alignItems: "center",
                              }
                            : {
                                height: "30px",
                                width: "50%",
                                float: "left",
                                display: "flex",
                                alignItems: "center",
                              }
                        }
                      >
                        {choosenFileName === "No file Choosen" && onlyView
                          ? "No file Choosen"
                          : choosenFileName}
                      </div>

                      <div
                        id="AddModel_uploadDownload_label"
                        className={cn(styles.upload_right_side_btn_container)}
                      >
                        <label
                          className={cn(styles.remove_Fild_btn)}
                          style={{
                            display:
                              toggleRemoveBtn === false
                                ? "none"
                                : choosenFileName === "No file Choosen"
                                ? "none"
                                : choosenFileName === "" && onlyView
                                ? "none"
                                : !onlyView &&
                                  choosenFileName.length !== "No file Choosen"
                                ? "flex"
                                : "none",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "28px",
                            width: "33px",
                            borderRadius: "5px",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            setChoosenFileName(() => "No files Choosen");
                            removeUploadFile(e);
                            setToggleRemoveBtn(false);
                          }}
                        >
                          X
                        </label>

                        <label
                          for="img"
                          style={{
                            display:
                              onlyView && choosenFileName !== "No file Choosen"
                                ? "flex"
                                : !onlyView
                                ? "flex"
                                : "none",
                            marginRight: "20px",
                            border: "none",
                            backgroundColor: "#23297a",
                            color: "white",
                            height: "28px",
                            padding: "6px 15px",
                            width: "120px",
                            float: "right",
                            textAlign: "center",
                            borderRadius: "5px",
                            cursor: "pointer",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          onClick={(e) => {
                            setToggleRemoveBtn(true);
                          }}
                        >
                          {onlyView && choosenFileName !== "No file Choosen"
                            ? "Download"
                            : !onlyView
                            ? "Upload File"
                            : ""}
                        </label>
                      </div>
                    </div>
                    <p>{formErrors.specFilePathError}</p>
                  </div>
                </div>

                <div
                  id="AddModel_Form_row4"
                  className={cn(styles.flex2, styles.flex2_layout)}
                >
                  {formValues.type === "VEHICLE" && (
                    <>
                      {" "}
                      <div
                        id="AddModel_TotalBatteries_block"
                        className={cn(styles.flex2_item)}
                      >
                        <div
                          id="AddModel_TotalBatteries"
                          className={cn(styles.block3, styles.block3_layout)}
                        >
                          <div
                            id="AddModel_TotalBatteries_label"
                            className={cn(
                              styles.text_body,
                              styles.text_body_layout
                            )}
                          >
                            {"Total Batteries*"}
                          </div>
                          <input
                            id="AddModel_TotalBatteries_input"
                            type="number"
                            name="totalBatteries"
                            className={cn(styles.line1, styles.line1_layout)}
                            value={formValues.totalBatteries}
                            onChange={handleChange}
                            disabled
                            max="10"
                            min={"0"}
                          />
                        </div>
                        <p>{formErrors.totalBatteries}</p>
                      </div>
                      <div className={cn(styles.flex2_spacer)} />{" "}
                      <div className={cn(styles.flex2_item)}></div>
                    </>
                  )}
                  {formValues.type === "BATTERY" && (
                    <>
                      <div
                        id="AddModel_ChargeCapacity_block"
                        className={cn(styles.flex2_item)}
                      >
                        <div
                          id="AddModel_ChargeCapacity"
                          className={cn(styles.block3, styles.block3_layout)}
                        >
                          <div
                            id="AddModel_ChargeCapacity_label"
                            className={cn(
                              styles.text_body,
                              styles.text_body_layout
                            )}
                          >
                            {"Charge Capacity(kWh)*"}
                          </div>
                          <input
                            id="AddModel_ChargeCapacity_input"
                            type="number"
                            step="0.01"
                            name="chargeCapacity"
                            className={cn(styles.line1, styles.line1_layout)}
                            value={formValues.chargeCapacity}
                            onChange={handleChange}
                            disabled={onlyView}
                          />
                        </div>
                        <p>{formErrors.chargeCapacity}</p>
                      </div>
                      <div className={cn(styles.flex2_spacer)} />
                      <div
                        id="AddModel_Year_block"
                        className={cn(styles.flex2_item)}
                      >
                        <div
                          id="AddModel_Year"
                          className={cn(styles.block3, styles.block3_layout)}
                        >
                          <div
                            id="AddModel_Year_label"
                            className={cn(
                              styles.text_body,
                              styles.text_body_layout
                            )}
                          >
                            {"Year*"}
                          </div>
                          <select
                            id="AddModel_Year_select"
                            name="year"
                            className={cn(
                              styles.line1,
                              styles.line1_layout,
                              styles.style_select
                            )}
                            value={formValues.year}
                            onChange={handleChange}
                            disabled={onlyView}
                          >
                            <option value={-1}>Select Year</option>
                            {unique.map((val) => {
                              return <option value={val}>{val}</option>;
                            })}
                          </select>
                        </div>
                        <p>{formErrors.year}</p>
                      </div>
                    </>
                  )}
                </div>

                <div
                  id="AddModel_Button_container"
                  className={cn(styles.flex9, styles.flex9_layout)}
                >
                  <div
                    id="AddModel_Button_container1"
                    className={cn(styles.flex9_item)}
                    onClick={routeChange}
                  >
                    <div
                      id="AddModel_BackButton_background"
                      className={cn(styles.block7, styles.block7_layout)}
                      style={onlyView ? { left: "20px" } : { left: "0px" }}
                    >
                      <h5
                        id="AddModel_BackButton_title"
                        className={cn(
                          styles.highlights1,
                          styles.highlights1_layout
                        )}
                      >
                        {onlyView ? "Back" : "Cancel"}
                      </h5>
                    </div>
                  </div>

                  <div className={cn(styles.flex9_spacer)} />
                  {action !== "view" ? (
                    <div
                      id="AddModel_SubmitButton_container"
                      className={cn(styles.flex9_item)}
                    >
                      <div
                        id="AddModel_SubmitButton_background"
                        onClick={handleSubmit}
                        className={cn(styles.block9, styles.block9_layout)}
                        style={{
                          backgroundColor: "#315CBB",
                          position: "absolute",
                          height: "45px",
                          width: "120px",
                          borderRadius: "5px",
                        }}
                      >
                        <h5
                          id="AddModel_SubmitButton_Title"
                          className={cn(
                            styles.highlights2,
                            styles.highlights2_layout
                          )}
                        >
                          {action}
                        </h5>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </form>
            <div className={cn(styles.flex2, styles.flex2_layout)}></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default function AddModel(props) {
  let Urls = window.location.href.toString().split(window.location.host)[1];
  const data = (data) => {
    headerFilterParms = data ? data : {};
  };

  useEffect(() => {
    data();
  }, []);
  return (
    <>
      <Master
        opts={props}
        screen={AddModelForm}
        showStatus={false}
        AddModelUrl={Urls}
        data={data}
      />
    </>
  );
}

AddModel.inStorybook = true;
